import { useMemo } from 'react';
import {
  MyUtilizationAnalytics,
  useMyUtilizationAnalyticsQuery
} from 'graphql/types';
import { useNoteInsightsContext } from 'modules/Insights/Notes/NoteInsightsContextProvider';

export const useGetMyUtilizationAnalyticsData = (): {
  data: MyUtilizationAnalytics[];
  loading: boolean;
  isEmpty: boolean;
} => {
  const { currentPeriod } = useNoteInsightsContext();
  const { startDate, endDate } = currentPeriod ?? {};
  const { loading, data } = useMyUtilizationAnalyticsQuery({
    variables: {
      input: {
        fromDate: startDate,
        toDate: endDate
      }
    }
  });
  return useMemo(
    () => ({
      data: data?.myUtilizationAnalytics?.items || [],
      loading,
      isEmpty: data?.myUtilizationAnalytics?.items.length === 0
    }),
    [data, loading]
  );
};
